import script from "./AuthFormMax.vue?vue&type=script&setup=true&lang=ts"
export * from "./AuthFormMax.vue?vue&type=script&setup=true&lang=ts"

import "./AuthFormMax.vue?vue&type=style&index=0&id=33316d77&lang=scss&scoped=true"

import exportComponent from "/home/dima/Work/pioneer-lk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-33316d77"]])

export default __exports__